import React from 'react';
import { connect } from 'react-redux';
import { getFormValues } from 'redux-form';
import { closeCreateNewContactPersonModal } from 'actions/ui';
import ModalPortal from 'components/ModalPortal';
import ConfirmModal from 'components/ConfirmModal';
import { CSSTransition } from 'react-transition-group';
import { destroy, reset } from 'redux-form';
import CreateNewContactPersonForm from './CreateNewContactPersonForm';
import { translate } from 'react-i18next';
import { KeyCodes } from 'constants/index';

const mapStateToProps = state => ({
	showCreateNewContactPersonModal: state.ui.showCreateNewContactPersonModal,
	values: getFormValues('create-new-contact-person')(state),
});

const mapDispatchToProps = dispatch => ({
	closeCreateNewContactPersonModal: () => dispatch(closeCreateNewContactPersonModal()),
	destroyForm: (form) => dispatch(destroy(form)),
});

@translate()
@connect(mapStateToProps, mapDispatchToProps)
class CreateNewContactPersonModal extends React.Component {
	state = {
		warningPopupOpen: false,
	};

	componentDidMount() {
		document.addEventListener('keydown', this.handleKeyPress);
	}

	componentWillUnmount() {
		document.removeEventListener('keydown', this.handleKeyPress);
		this.props.destroyForm('create-new-contact-person');
	}

	isFormValuesEmpty = () => {
		const { values } = this.props;

		if (values) {
			return !Object.values(values)
				.some(value => {
					if (typeof value === 'string') {
						return Boolean(value.trim());
					}

					return Boolean(value);
				});
		}

		return true;
	};

	onClose = () => {
		this.isFormValuesEmpty()
			? this.props.closeCreateNewContactPersonModal()
			: this.handleOpenWarningPopup();
	};

	handleKeyPress = (e) => {
		if (e.keyCode === KeyCodes.ESCAPE) {
			this.onClose();
		}
	};

	handleOpenWarningPopup = () => this.setState({ warningPopupOpen: true });

	handleCloseWarningPopup = () => this.setState({ warningPopupOpen: false });

	onClickDangerButton = () => {
		this.handleCloseWarningPopup();
		this.props.closeCreateNewContactPersonModal();
	};

	render() {
		const { showCreateNewContactPersonModal, t } = this.props;
		return (
			<>
				{!this.state.warningPopupOpen && (
					<CSSTransition
						appear
						enter
						exit
						mountOnEnter
						unmountOnExit
						in={showCreateNewContactPersonModal}
						classNames="fade"
						timeout={500}
					>
						<ModalPortal
							className="create-customer-modal"
							onClose={this.onClose}
						>
							<CreateNewContactPersonForm />
						</ModalPortal>
					</CSSTransition>
				)}

				{this.state.warningPopupOpen && (
					<ConfirmModal
						onClose={this.handleCloseWarningPopup}
						dangerButton
						secondaryButton
						titleModal="Зверніть увагу!"
						contentModalText="Всі незбережені дані будуть втрачені. Ви дійсно бажаєте закрити?"
						dangerButtonText="Закрити"
						secondaryButtonText={t('cancel')}
						onClickDangerButton={this.onClickDangerButton}
						onClickSecondaryButton={this.handleCloseWarningPopup}
					/>
				)}
			</>
		);
	}
}

export default CreateNewContactPersonModal;
